/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 */

import {Component, inject} from '@angular/core';
import {IxActiveModal} from '@siemens/ix-angular';

/** Data returned when the user confirms the decline action. */
export interface DeclineAccessRequestResult {
  reason: string;
}

@Component({
  selector: 'app-modal-decline-access-request',
  templateUrl: './modal-decline-access-request.component.html',
  standalone: false,
})
export class ModalDeclineAccessRequestComponent {
  readonly activeModal = inject(IxActiveModal);

  reason = '';

  confirm(): void {
    this.activeModal.close({reason: this.reason.trim()});
  }
}
